import { render, staticRenderFns } from "./FactoryVRUpload.vue?vue&type=template&id=27ee1a0f"
import script from "./FactoryVRUpload.vue?vue&type=script&lang=js"
export * from "./FactoryVRUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports